import React from "react";
import PodcastSingle from "../../../components/OrPodcastSingle";

const PodcastSingleWidget = props => <PodcastSingle {...props} />;

export default PodcastSingleWidget;
